export type TypeOf =
  | 'array'
  | 'string'
  | 'number'
  | 'bigint'
  | 'boolean'
  | 'symbol'
  | 'undefined'
  | 'object'
  | 'function';

export type TypeMap = {
  array: unknown[];
  string: string;
  number: number;
  bigint: bigint;
  boolean: boolean;
  symbol: symbol;
  undefined: undefined;
  object: object;
  // eslint-disable-next-line @typescript-eslint/ban-types
  function: Function;
};

export type Class<T = unknown> = {
  new (...args: unknown[]): T;
};

export type ClassInstance<C extends Class> = C extends Class<infer R>
  ? R
  : never;

function isType<T extends TypeOf>(value: unknown, type: T): value is TypeMap[T];
function isType<C extends Class>(
  value: unknown,
  type: C,
): value is ClassInstance<C>;
function isType(value: unknown, type: TypeOf | Class): boolean {
  if (typeof type === 'string') {
    return type === 'array' ? Array.isArray(value) : typeof value === type;
  }
  return value instanceof type;
}

export default isType;
